"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../../@i18n");
var _apis = require("../../../../@apis");
var _store = require("../../../../@api/store");
var _functions = require("../../../../@functions");
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _Spinner = _interopRequireDefault(require("../../../Spinner"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @typedef AccountPageProps
 * @type {import("../../index").AccountPageProps}
 */

/** @param {AccountPageProps} props */
function Security(props) {
  var auth = props.auth;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    oldPassword = _useState2[0],
    setOldPassword = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    newPassword = _useState4[0],
    setNewPassword = _useState4[1];
  var _useState5 = (0, _react.useState)(!!auth.user.signInWith2fa),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    twoFactorAuth = _useState6[0],
    setTwoFactorAuth = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    codeSent = _useState10[0],
    setCodeSent = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    inputCode = _useState12[0],
    setInputCode = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    wrongCode = _useState14[0],
    setWrongCode = _useState14[1];
  var _useState15 = (0, _react.useState)((0, _functions.onlyNumbers)(auth.user.phoneCountry)),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    countryCode = _useState16[0],
    setCountryCode = _useState16[1];
  var _useState17 = (0, _react.useState)((0, _functions.onlyNumbers)(auth.user.phoneArea)),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    areaCode = _useState18[0],
    setAreaCode = _useState18[1];
  var _useState19 = (0, _react.useState)((0, _functions.onlyNumbers)(auth.user.phone)),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    phone = _useState20[0],
    setPhone = _useState20[1];

  /**
   * @param {"inputCode" | "countryCode" | "areaCode" | "phone"} type
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>) => void}
   */
  var handleChange = function handleChange(type) {
    return function (evt) {
      var setStaters = {
        inputCode: setInputCode,
        countryCode: setCountryCode,
        areaCode: setAreaCode,
        phone: setPhone
      };
      var value = (0, _functions.onlyNumbers)(evt.target.value);
      var setState = setStaters[type];
      setState(value);
    };
  };
  var handleCheck2FaAuth = function handleCheck2FaAuth() {
    var _auth$company;
    var checked = !twoFactorAuth;
    setTwoFactorAuth(checked);
    auth.user.signInWith2fa = checked;
    if (!checked) {
      auth.user.approved2fa = {};
    }
    _apis.appcenterApi.company.users.save((_auth$company = auth.company) === null || _auth$company === void 0 ? void 0 : _auth$company.uid, auth.user);
  };
  var handleGenerate2faCode = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _auth$company2;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            auth.user.phoneCountry = countryCode;
            auth.user.phoneArea = areaCode;
            auth.user.phone = phone;
            _context.next = 7;
            return _apis.appcenterApi.company.users.save((_auth$company2 = auth.company) === null || _auth$company2 === void 0 ? void 0 : _auth$company2.uid, auth.user);
          case 7:
            _context.next = 9;
            return _apis.appcenterApi.auth.twoFa.generateCode(auth.user);
          case 9:
            setCodeSent(true);
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            console.error('Error', _context.t0);
            _store.services.message.show('Algum erro inesperado ocorreu ao salvar as configurações de autenticação de duas etapas');
          case 16:
            _context.prev = 16;
            setLoading(false);
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12, 16, 19]]);
    }));
    return function handleGenerate2faCode() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleVerify2faCode = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var response, _auth$company3;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            setWrongCode(false);
            _context2.prev = 2;
            _context2.next = 5;
            return _apis.appcenterApi.auth.twoFa.verifyCode(auth.user, inputCode);
          case 5:
            response = _context2.sent;
            if (!(response.data === 'invalid-code')) {
              _context2.next = 10;
              break;
            }
            setWrongCode(true);
            _context2.next = 14;
            break;
          case 10:
            auth.user.signInWith2fa = true;
            auth.user.approved2fa = {
              countryCode: countryCode,
              areaCode: areaCode,
              phone: phone,
              date: new Date()
            };
            _context2.next = 14;
            return _apis.appcenterApi.company.users.save((_auth$company3 = auth.company) === null || _auth$company3 === void 0 ? void 0 : _auth$company3.uid, auth.user);
          case 14:
            _context2.next = 20;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](2);
            console.error('Error', _context2.t0);
            _store.services.message.show('Erro ao verificar código de autenticação de duas etapas');
          case 20:
            _context2.prev = 20;
            setLoading(false);
            return _context2.finish(20);
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 16, 20, 23]]);
    }));
    return function handleVerify2faCode() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSaveNewPassword = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return _apis.appcenterApi.auth.changePassword(auth.user.email, oldPassword, newPassword);
          case 3:
            _store.services.message.show('Senha atualizada com sucesso');
            _context3.next = 10;
            break;
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
            _store.services.message.show('Não foi possível atualizar senha', 'Verifique a senha atual. Ela precisa estar correta para a atualização funcionar');
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 6]]);
    }));
    return function handleSaveNewPassword() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleResetChanges = function handleResetChanges() {
    setNewPassword('');
    setOldPassword('');
  };
  var canConfirm = (0, _react.useMemo)(function () {
    return !!(countryCode && areaCode && phone);
  }, [countryCode, areaCode, phone]);
  var canVerifyCode = (0, _react.useMemo)(function () {
    return !!inputCode;
  }, [inputCode]);
  var twoFaApproved = (0, _react.useMemo)(function () {
    var _auth$user$approved2f;
    return twoFactorAuth && !!((_auth$user$approved2f = auth.user.approved2fa) !== null && _auth$user$approved2f !== void 0 && _auth$user$approved2f.date);
  }, [twoFactorAuth, auth.user.approved2fa]);
  var twoFaIsDisabled = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("p", null, "A autentica\xE7\xE3o em dois fatores ainda n\xE3o est\xE1 habilitada")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-actions"
  }, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-security-saveChanges",
    onClick: handleCheck2FaAuth
  }, "HABILITAR AUTENTICA\xC7\xC3O EM DOIS FATORES")));
  var informPhoneNumber = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Insira os dados de telefone para completar a autentica\xE7\xE3o em duas etapas. ", /*#__PURE__*/_react["default"].createElement("br", null), "Ser\xE1 enviado um c\xF3digo ao seu telefone para fazer a verifica\xE7\xE3o de propriedade."), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "C\xF3digo do pa\xEDs",
    onChange: handleChange('countryCode'),
    value: countryCode
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "C\xF3digo de \xE1rea",
    onChange: handleChange('areaCode'),
    value: areaCode
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "N\xFAmero de telefone",
    onChange: handleChange('phone'),
    value: phone,
    mask: "99999-9999"
  }), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    onClick: handleGenerate2faCode,
    disabled: !canConfirm
  }, "ENVIAR C\xD3DIGO"));
  var inputCodeSentBySMS = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Um c\xF3digo foi enviado ao seu telefone ", auth.user.phoneCountry, auth.user.phoneArea, auth.user.phone), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "C\xF3digo de verifica\xE7\xE3o",
    onChange: handleChange('inputCode'),
    value: inputCode
  }), wrongCode && /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-security-error"
  }, "* C\xF3digo inv\xE1lido"), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    onClick: handleVerify2faCode,
    disabled: !canVerifyCode
  }, "VERIFICAR C\xD3DIGO"));
  var loadingSpinner = /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-spinnerContainer"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null));
  var twoFaApprovationData = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Telefone ", auth.user.approved2fa.countryCode, auth.user.approved2fa.areaCode, auth.user.approved2fa.phone, /*#__PURE__*/_react["default"].createElement("br", null), "Verificado em ", _i18n.format.datetime((0, _functions.toDate)(auth.user.approved2fa.date))), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    onClick: handleCheck2FaAuth
  }, "DESABILITAR VERIFICA\xC7\xC3O EM DUAS ETAPAS"));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security",
    "data-fullwidth": true,
    "data-fullheight": true
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "Account-security-section"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "Account-title"
  }, "Alterar senha"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-columns",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-rows",
    "data-align-y": "center",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    isPassword: true,
    label: "Senha atual",
    placeholder: "Ex. 1234",
    onChange: function onChange(evt) {
      return setOldPassword(evt.target.value);
    },
    value: oldPassword
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    fullWidth: true,
    isPassword: true,
    label: "Nova senha",
    placeholder: "Ex. 4321",
    onChange: function onChange(evt) {
      return setNewPassword(evt.target.value);
    },
    value: newPassword
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-rows",
    "data-align-y": "center",
    "data-fullwidth": true
  }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "M\xEDnimo de 8 caracteres. Quanto mais, melhor;"), /*#__PURE__*/_react["default"].createElement("li", null, " Pelo menos um caractere min\xFAsculo e um mai\xFAsculo;"), /*#__PURE__*/_react["default"].createElement("li", null, " Pelo menos um n\xFAmero e um s\xEDmbolo.")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-security-actions"
  }, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-security-saveChanges",
    onClick: handleSaveNewPassword
  }, "SALVAR ALTERA\xC7\xD5ES"), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-security-resetChanges",
    onClick: handleResetChanges
  }, "RESETAR"))), /*#__PURE__*/_react["default"].createElement("section", {
    className: "Account-security-section"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "Account-title"
  }, "Verifica\xE7\xE3o em duas etapas"), twoFaApproved ? twoFaApprovationData : !twoFactorAuth ? twoFaIsDisabled : !loading ? !codeSent ? informPhoneNumber : inputCodeSentBySMS : loadingSpinner));
}
var _default = Security;
exports["default"] = _default;